import { jsx } from "react/jsx-runtime";
import { useLanguage, useTranslations } from "@vocab/react";
import { Box } from "braid-design-system";
import { translations as translations$1 } from "../../../../components/ProfileMonthPicker/.vocab/index.mjs";
import { compatibility, translations } from "@seek/ca-myprofile-utils";
import { useState, useEffect } from "react";
import { profileMonthPickerWidth } from "./ProfileMonthPickerRenderer.css.mjs";
const useCompatibleLanguage = () => {
  const { language: vocabLanguage } = useLanguage();
  const language = compatibility.getCompatibleLanguageFromLocaleString(vocabLanguage);
  return language;
};
const useMonthNames = () => {
  const language = useCompatibleLanguage();
  const [monthNames, setMonthNames] = useState();
  useEffect(() => {
    let shouldSetMonthNames = true;
    translations.getAbbreviatedMonthsMessages(language).then((messages) => {
      const monthNamesList = [
        messages.Jan.format(),
        messages.Feb.format(),
        messages.Mar.format(),
        messages.Apr.format(),
        messages.May.format(),
        messages.Jun.format(),
        messages.Jul.format(),
        messages.Aug.format(),
        messages.Sep.format(),
        messages.Oct.format(),
        messages.Nov.format(),
        messages.Dec.format()
      ];
      if (shouldSetMonthNames) {
        setMonthNames(monthNamesList);
      }
      return () => {
        shouldSetMonthNames = false;
      };
    });
  }, [language]);
  return monthNames;
};
const ProfileMonthPickerRenderer = ({
  children,
  "data-automation": dataAutomation
}) => {
  const monthNames = useMonthNames();
  const { t } = useTranslations(translations$1);
  return /* @__PURE__ */ jsx(Box, { className: profileMonthPickerWidth, "data-automation": dataAutomation, children: children({
    monthPickerProps: {
      monthNames,
      monthLabel: t("Month"),
      yearLabel: t("Year")
    }
  }) });
};
export {
  ProfileMonthPickerRenderer,
  useCompatibleLanguage,
  useMonthNames
};
